"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _Loading = require("./Loading.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * loading ~
 */

const Loading = () => {
  return /*#__PURE__*/_react.default.createElement(_Loading.UiLoading, null, /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    indicator: /*#__PURE__*/_react.default.createElement(_icons.Loading3QuartersOutlined, {
      spin: true
    }),
    size: "large"
  }));
};
var _default = exports.default = Loading;